import { Modal, Button } from "antd";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

const CustomModal = (props) => {
  const {
    visible,
    title,
    closable,
    okTxt,
    hideFooter,
    hideCancel,
    cancelTxt,
    onCancel,
    onOk,
    btnDisabled,
    className,
    children,
  } = props;
  const ModelWrapper = styled.div``;
  return (
    <ModelWrapper>
      <style>
        {`.${className || "custom-model"} .ant-modal-header {
        border-radius: 12px 12px 0 0;
      }`}
      </style>
      <Modal
        headerStyle={{ borderRadius: " 12px 12px 0 0" }}
        centered
        title={title}
        open={visible}
        onCancel={onCancel}
        closable={closable}
        closeIcon={<FontAwesomeIcon icon={faTimes} color={"#7D83A6"} />}
        className={className || "custom-model"}
        destroyOnClose
        zIndex="999"
        footer={
          !hideFooter && (
            <>
              <Button
                onClick={onOk}
                className={`right-btn`}
                disabled={btnDisabled}
                type="primary"
              >
                {okTxt}
              </Button>
              {!hideCancel && (
                <Button
                  className="app-cancel-btn footer-btn"
                  onClick={onCancel}
                >
                  {cancelTxt || "Cancel"}
                </Button>
              )}
            </>
          )
        }
      >
        {children}
      </Modal>
    </ModelWrapper>
  );
};

export default CustomModal;
